import React from 'react'
import { FacilityCategoryBase } from './styles'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import CategoryIcon from './CategoryIcon'
import { FacilityCategories } from './Categories'

interface IFacilityCategory {
  code: FacilityCategories
  hideIcon?: boolean
}

const FacilityCategory = ({ code, hideIcon = false }: IFacilityCategory) => {
  return (
    <FacilityCategoryBase>
      {!hideIcon && code && <CategoryIcon code={code} />}
      <FormattedMessage
        tagName="h3"
        {...(messages[code as keyof typeof messages] || messages.facilities)}
      />
    </FacilityCategoryBase>
  )
}

export default FacilityCategory
